import { formatBooleanToYesNo } from './booleanToYesNo'

export function formatBooleanOrNullToYesNo(bool: boolean | null) {
  if (bool === null) {
    return ''
  }
  return formatBooleanToYesNo(bool)
}